exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-blockquote-footer-right {\n  text-align: right;\n}\n.uu5-bricks-blockquote-footer-right:before {\n  content: '';\n}\n.uu5-bricks-blockquote-footer-right:after {\n  content: '\\A0   \\2014';\n}\n.uu5-bricks-blockquote-footer-left {\n  text-align: left;\n}\n.blockquote-reverse .uu5-bricks-blockquote-footer-left:before {\n  content: '\\2014   \\A0';\n}\n.blockquote-reverse .uu5-bricks-blockquote-footer-left:after {\n  content: '';\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/blockquote-footer.less
// module id = 187
// module chunks = 0